var ButtonColor;
(function(ButtonColor) {
    ButtonColor["grey"] = "grey";
    ButtonColor["blue"] = "blue";
    ButtonColor["red"] = "red";
    ButtonColor["black"] = "black";
    ButtonColor["white"] = "white";
    ButtonColor["yellow"] = "yellow";
})(ButtonColor || (ButtonColor = {}));

export { ButtonColor };
